import React, { useEffect, useCallback } from 'react';

import theme from 'theme';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { UserContext } from 'context';
import { FETCH_STATE } from 'constants';
import StatisticBox from './StatisticBox';
import useStyles from './Statistics.styled';
import InfoIcon from '@material-ui/icons/Info';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography, Tooltip } from '@material-ui/core';
import { DashboardActions } from 'state/modules/dashboard';

const Statistics = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { orgType } = React.useContext(UserContext);

  const reservationStats = useSelector((state) => state.dashboard.reservationStats);
  const vehicleStats = useSelector((state) => state.dashboard.vehicleStats);
  const fetchingReservationStats = useSelector((state) => state.dashboard.fetchingReservationStats);
  const fetchingVehicleStats = useSelector((state) => state.dashboard.fetchingVehicleStats);

  const getStats = useCallback(() => {
    if (orgType !== 'msOwnerOrg') {
      dispatch(DashboardActions.fetchReservationStats());
    }
    dispatch(DashboardActions.fetchVehicleStats());
  }, [orgType]);

  useEffect(() => {
    orgType && getStats();
  }, [orgType]);

  const loadingStats =
    fetchingReservationStats == FETCH_STATE.LOADING || fetchingVehicleStats == FETCH_STATE.LOADING;

  return (
    <Card
      enableCollapse
      id="statistics-widget"
      headerActionType="vertical"
      title={i18n.t(`dashboard.${orgType !== 'msOwnerOrg' ? 'vehicles_reservations' : 'vehicles'}`)}
      onRefresh={() => getStats()}
      headerActionType="vertical"
      loading={loadingStats}
    >
      <Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={orgType !== 'msOwnerOrg' ? 6 : 12}
          lg={orgType !== 'msOwnerOrg' ? 8 : 12}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                className={classes.boxTitle}
                style={{ backgroundColor: theme.palette.general.extraLightGreen }}
              >
                <Typography>
                  <Box
                    alignItems="center"
                    component="span"
                    display="flex"
                    className={classes.boxLabel}
                    style={{ color: theme.palette.general.green }}
                  >
                    {i18n.t('common.vehicles')}
                    <Tooltip
                      title={i18n.t('dashboard.statistics.vehicles_description')}
                      placement="right"
                    >
                      <InfoIcon className={classes.infoIcon} />
                    </Tooltip>
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <StatisticBox
                count={vehicleStats?.active || 0}
                color={theme.palette.general.green}
                label={i18n.t(`common.active`)}
                link="/vehicles?status_filter=only&statuses=ACTIVE"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <StatisticBox
                count={vehicleStats?.inshop || 0}
                color={theme.palette.general.red}
                label={i18n.t(`common.in_shop`)}
                link="/vehicles?status_filter=only&statuses=INSHOP"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <StatisticBox
                count={vehicleStats?.inactive || 0}
                color={theme.palette.general.grey}
                label={i18n.t(`common.inactive`)}
                link="/vehicles?status_filter=only&statuses=INACTIVE"
              />
            </Grid>
          </Grid>
        </Grid>
        {orgType && orgType !== 'msOwnerOrg' && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  className={classes.boxTitle}
                  style={{ backgroundColor: theme.palette.general.extraLightBlue }}
                >
                  <Typography>
                    <Box
                      alignItems="center"
                      component="span"
                      display="flex"
                      className={classes.boxLabel}
                      style={{ color: theme.palette.general.blue }}
                    >
                      {i18n.t('common.reservations')}
                      <Tooltip
                        title={i18n.t('dashboard.statistics.reservations_description')}
                        placement="right"
                      >
                        <InfoIcon className={classes.infoIcon} />
                      </Tooltip>
                    </Box>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <StatisticBox
                  count={reservationStats?.reserved || 0}
                  color={theme.palette.general.lightBlue}
                  label={i18n.t(`common.reserved`)}
                  link="/reservations?statuses=RESERVED"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <StatisticBox
                  count={reservationStats?.inprogress || 0}
                  color={theme.palette.general.lightBlue}
                  label={i18n.t(`common.inprogress`)}
                  link="/reservations?statuses=INPROGRESS"
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default Statistics;
